module.exports = __webpack_public_path__ + "img/hr-coal.ef372a88.png";